/**
 * @file EndConversationDailog.jsx
 * @description EndConversationDailog component for displaying and managing end conversation dialog.
 * @component EndConversationDailog
 * @exports EndConversationDailog - Main component for displaying and managing end conversation dialog.
 */

import React from "react";
import {
    Button,
    Typography,
  } from "@mui/material";

import DialogComponent from "../../../common/components/DialogComponent.jsx";
import { TEXT_STRING,TEXT_MESSAGE } from "../../../common/constants/agentModule/textConstants.js";
import { VARIANTS, BUTTON_COLORS } from "../../../common/constants/commonConstants.js";
const EndConversationDailog = ({open,onConfirm, onClose}) => {
  return (
    <div>
      {
        <DialogComponent
          open={open}
          onClose={onClose}
          title={TEXT_STRING.END_CONVERSATION_DAILOG_HEADER}
          actions={
            <Button
              onClick={onConfirm}
              color={BUTTON_COLORS.PRIMARY}
              variant={VARIANTS.CONTAINED}
            >
              Confirm
            </Button>
          }
        >
          <Typography variant={VARIANTS.BODY}>
            {TEXT_MESSAGE.END_CONVERSATION_DAILOG_MESSAGE}
          </Typography>
        </DialogComponent>
      }
    </div>
  );
};

export default EndConversationDailog;
